import {Popover} from "antd";

export const PlantTagWidget = ({tag, onClick, popOver, props}) => {
    const tagStyle = {
        cursor: 'pointer',
        color: "#108ee9",
        marginLeft: '5px',
        marginRight: '5px'
    }

    const onTagClick = () => {
        if (onClick) onClick();
    }

    if (popOver) {
        return <Popover content={popOver}><div onClick={onTagClick} style={tagStyle}>{`${tag.name}`}</div></Popover>
    }
    return <div onClick={onTagClick} style={tagStyle}>{`${tag.name}`}</div>
}